import * as React from "react";

const TrashIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15.9" height="17.5" viewBox="0 0 15.9 17.5">
            <g id="Icon_feather-trash-2" data-name="Icon feather-trash-2" transform="translate(-3.75 -2.25)">
                <path
                    id="Path_90"
                    data-name="Path 90"
                    d="M4.5,9H18.9"
                    transform="translate(0 -2.8)"
                    fill="none"
                    stroke="#89483B"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                />
                <path
                    id="Path_91"
                    data-name="Path 91"
                    d="M18.7,6.2V17.4A1.6,1.6,0,0,1,17.1,19h-8a1.6,1.6,0,0,1-1.6-1.6V6.2m2.4,0V4.6A1.6,1.6,0,0,1,11.5,3h3.2a1.6,1.6,0,0,1,1.6,1.6V6.2"
                    transform="translate(-1.4)"
                    fill="none"
                    stroke="#89483B"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                />
                <path
                    id="Path_92"
                    data-name="Path 92"
                    d="M15,16.5v4.8"
                    transform="translate(-4.9 -6.3)"
                    fill="none"
                    stroke="#89483B"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                />
                <path
                    id="Path_93"
                    data-name="Path 93"
                    d="M21,16.5v4.8"
                    transform="translate(-7.7 -6.3)"
                    fill="none"
                    stroke="#89483B"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                />
            </g>
        </svg>
    );
};

export default React.memo(TrashIcon);
